module.exports = __webpack_public_path__ + "img/bscx.b914a660.jpg";